import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useGoogleFontPreload } from '../hooks/useGoogleFontPreload';
import { useGoogleAuth } from '../hooks/useGoogleAuth';

const GoogleButtonWrapper = styled.div`
  margin-top: 16px;
  position: relative;
  width: 100%;
  height: 44px;
`;

const GoogleButtonContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  cursor: pointer;
`;

const CustomGoogleButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Google Sans', sans-serif;
  gap: 8px;
  padding: 10px;
  border-radius: 4px;
  background-color: #ffffff;
  border: 1px solid #dadce0;
  color: #3c4043;
  outline: none;
  font-weight: 500;
  letter-spacing: 0.25px;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;
  z-index: 2;
  pointer-events: none;
  max-width: 343px;
  margin: 0 auto;
`;

const GoogleLogo = styled.img`
  width: 24px;
  height: 24px;
`;

const Separator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0;
  font-size: 14px;
  color: #848484;
  width: 100%;

  span {
    margin: 0 10px;
    white-space: nowrap;
    flex: 1;
    text-align: center;
  }

  &:before,
  &:after {
    content: '';
    display: block;
    height: 1px;
    width: 100px;
    background-color: #e9e9e9;
  }
`;

export const AppGoogleSignInButton = () => {
  useGoogleFontPreload();
  const { t } = useTranslation();
  const { handleCustomButtonClick } = useGoogleAuth();

  return (
    <>
      <GoogleButtonWrapper>
        <GoogleButtonContainer id="googleSignInButton" />
        <CustomGoogleButton onClick={handleCustomButtonClick}>
          <GoogleLogo src="./assets/google_btn.svg" alt="Google" />
          {t('continue_with_google')}
        </CustomGoogleButton>
      </GoogleButtonWrapper>
      <Separator>
        <span>{t('or')}</span>
      </Separator>
    </>
  );
};

export default AppGoogleSignInButton;
